import produce from "immer";
import {
  SET_ADDRESS_LIST,
  SET_ADDRESS_LOADING,
  SET_DELIVERY_SHIFT_RESTRICTIONS_FOR_STORE,
  SET_DELIVERY_SHIFT_RESTRICTIONS_LOADING,
} from "app/utils/constants/address";
import type { DeliveryShiftRestrictionRow } from "app/types/deliveryShiftConfiguration";

interface AddressState {
  address_list: unknown[];
  addressLoading: boolean | null;
  deliveryShiftRestrictionsByStore: Record<number, DeliveryShiftRestrictionRow[]>;
  deliveryShiftRestrictionsLoading: boolean;
}

const initialState: AddressState = {
  address_list: [],
  addressLoading: null,
  deliveryShiftRestrictionsByStore: {},
  deliveryShiftRestrictionsLoading: false,
};

export default produce((draft, action) => {
  switch (action.type) {
    case SET_ADDRESS_LIST:
      draft.address_list = action.payload;
      break;
    case SET_ADDRESS_LOADING:
      draft.addressLoading = action.payload;
      break;
    case SET_DELIVERY_SHIFT_RESTRICTIONS_FOR_STORE:
      draft.deliveryShiftRestrictionsByStore[action.payload.storeId] =
        action.payload.restrictions;
      break;
    case SET_DELIVERY_SHIFT_RESTRICTIONS_LOADING:
      draft.deliveryShiftRestrictionsLoading = action.payload;
      break;
    default:
      return draft;
  }
}, initialState);
